const getEnvironmentInfo = () => {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : '';
  const isProd = hostname === import.meta.env.VITE_PRD_HOST;
  return {hostname, isProd};
};

const isValidKey = (key) => key && typeof key === 'string' && key.trim() !== '';

export const initializeRecaptchaSiteKey = () => {
  const {isProd} = getEnvironmentInfo();

  try {
    const key = isProd
      ? import.meta.env.VITE_RECAPTCHA_SITE_KEY_PRD
      : import.meta.env.VITE_RECAPTCHA_SITE_KEY_HML;

    if (isValidKey(key)) {
      return key;
    }

    if (isProd) {
      throw new Error('VITE_RECAPTCHA_SITE_KEY_PRD is required in production');
    }
    console.info('reCAPTCHA disabled: VITE_RECAPTCHA_SITE_KEY not configured');
    return '';
  } catch (error) {
    if (isProd) {
      throw error;
    }
    console.error('Error initializing reCAPTCHA configuration:', error.message);
    return '';
  }
};

export const RECAPTCHA_SITE_KEY = initializeRecaptchaSiteKey();

export const RECAPTCHA_ACTIONS = {
  QUOTATION_SUBMISSION: 'quotation_submission',
  DATA_UPDATE: 'data_update',
  FINANCIAL_DATA: 'financial_data',
  TERMS_ACCEPTANCE: 'terms_acceptance'
};

const DEFAULT_CONFIG = {
  TIMEOUT: 5000,
  RETRY_ATTEMPTS: 2,
  FALLBACK_ENABLED: true
};

// Factory function for creating config from Remote Config
export const createRecaptchaConfig = (remoteConfig = {}) => {
  return {
    ENABLED: Boolean(RECAPTCHA_SITE_KEY) && remoteConfig.enabled !== false,
    TIMEOUT: remoteConfig.timeout ?? DEFAULT_CONFIG.TIMEOUT,
    RETRY_ATTEMPTS:
      remoteConfig.retry_attempts ?? DEFAULT_CONFIG.RETRY_ATTEMPTS,
    FALLBACK_ENABLED:
      remoteConfig.fallback_enabled ?? DEFAULT_CONFIG.FALLBACK_ENABLED
  };
};

export const RECAPTCHA_ERROR_MESSAGES = {
  TOKEN_MISSING: 'Token reCAPTCHA obrigatório',
  VALIDATION_FAILED: 'Falha na validação de segurança',
  SERVICE_UNAVAILABLE: 'Serviço de segurança temporariamente indisponível',
  NETWORK_ERROR: 'Erro de conexão durante validação'
};
